export const hasBackground = (backgroundColor?: string | null): boolean =>
  !!(
    backgroundColor &&
    backgroundColor !== "none" &&
    backgroundColor !== "transparent"
  );
